import { lazy, Suspense } from 'react';

const EnterCode = lazy(() => import('@pages/security/2FA/EnterCode'));
const SetTOTPPage = lazy(() => import('@pages/security/2FA/SetTOTPPage'));
const ChangePassword = lazy(() => import('@pages/security/ChangePassword'));
const SecurityPage = lazy(() => import('@pages/security/SecurityPage'));
const SetPassword = lazy(() => import('@pages/security/SetPassword'));

// Rest of the code remains the same
import LoadingModal from '@components/atoms/modals/LoadingModal';
import { AnalyticsScreenName } from 'mh-client';
import { Route } from 'react-router';
import ProtectedRoute from './components/ProtectedRoute';

const Names = AnalyticsScreenName.getInstance();

const SecurityRoutes = (
    <>
        <Route
            path="/security"
            element={
                <ProtectedRoute
                    accountStatus={[
                        'None',
                        'Pending',
                        'KycVerified',
                        'KycDeclined',
                        'Complete',
                    ]}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <SecurityPage />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.SECURITY_SETTINGS }}
        />
        <Route
            path="/security/setpassword"
            element={
                <ProtectedRoute
                    accountStatus={[
                        'None',
                        'Pending',
                        'KycVerified',
                        'KycDeclined',
                        'Complete',
                    ]}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <SetPassword />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.SET_PASSWORD }}
        />
        <Route
            path="/security/changepassword"
            element={
                <ProtectedRoute
                    accountStatus={[
                        'None',
                        'Pending',
                        'KycVerified',
                        'KycDeclined',
                        'Complete',
                    ]}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <ChangePassword />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.CHANGE_PASSWORD }}
        />
        <Route
            path="/security/totp/enable"
            element={
                <ProtectedRoute
                    accountStatus={[
                        'None',
                        'Pending',
                        'KycVerified',
                        'KycDeclined',
                        'Complete',
                    ]}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <SetTOTPPage />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.SETUP_TOTP }}
        />
        <Route
            path="/security/totp/entercode"
            element={
                <ProtectedRoute
                    accountStatus={[
                        'None',
                        'Pending',
                        'KycVerified',
                        'KycDeclined',
                        'Complete',
                    ]}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <EnterCode />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.REAUTH_TOTP }}
        />
    </>
);

export default SecurityRoutes;
